module.exports = __webpack_public_path__ + "assets/img/15_336.85aefce0.jpg";